import { useLanguageContext } from "../i18n/components/LanguageProvider";
import * as languageStrings from '../i18n/localization';

const useLanguageStrings = () => {
  const language = useLanguageContext();
  return languageStrings[language];
}

export default useLanguageStrings;
